// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "service_agent".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "service_agent" table (1:1 with a DB row, on the wire). */
export const serviceAgentAtomSchema = z.object({
    id: z.string(),
    organizationServiceId: z.string(),
    agentSlug: z.string(),
    isPrimary: z.boolean(),
    source: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=serviceAgent.js.map